/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum DataPermissions {
    View = 0,
    Edit = 1,
    Add = 2,
    Delete = 3,
    Export = 4,
    Duplicate = 5,
    UploadCloud = 6,
    CreateSession = 7,
    JoinTraining = 8,
}
